<template>
  <div>
    <button type="button" class="mobile-nav-toggle d-xl-none"><i class="icofont-navigation-menu"></i></button>

    <!-- ======= Header ======= -->
    <header id="header" class="d-flex flex-column justify-content-center">
      <nav class="nav-menu">
        <ul>
          <li class="active"><a href="#hero"><i class="bx bx-home"></i> <span>Inicio</span></a></li>
          <li><a href="#about"><i class="bx bx-user"></i> <span>Acerca de mí</span></a></li>
          <li><a href="#resume"><i class="bx bx-file-blank"></i> <span>Experiencia profesional</span></a></li>
          <li><a href="#portfolio"><i class="bx bx-book-content"></i> <span>Portafolio</span></a></li>
          <!--li><a href="#services"><i class="bx bx-server"></i> <span>Servicios</span></a></li-->
          <li><a href="#contact"><i class="bx bx-envelope"></i> <span>Contacto</span></a></li>
        </ul>
      </nav>
      <!-- .nav-menu -->
    </header>
    <!-- End Header -->
    <HomeComponent/>
    <AboutComponent/>
    <MainComponent/>
    <FooterComponent/>
  </div>
</template>

<script>

import HomeComponent from "@/components/HomeComponent";
import FooterComponent from "@/components/FooterComponent";
import AboutComponent from "@/components/AboutComponent";
import MainComponent from "@/components/MainComponent";
export default {
  name: 'App',
  components: {
    MainComponent,
    AboutComponent,
    FooterComponent,
    HomeComponent
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
